import loginLogoImg from './LoginLogo.svg'

export const AppbarBpacLogo = loginLogoImg
